import React from 'react';

const backdrop = props => (
    <div className={'Backdrop ' + (props.className ? props.className : '') + (typeof props.show !== 'undefined' ? props.show : '' )} onClick={props.clicked}></div>
)

export default backdrop;